/**
 * Exit Intent - mouse saindo pelo topo ou visibility hidden; dispara callback uma vez por página.
 * Aggregator enfileira EXIT_INTENT.
 */

let exitIntentFired = false;
let onExitIntent: (() => void) | null = null;
let mouseOutListener: ((e: MouseEvent) => void) | null = null;
let visibilityListener: (() => void) | null = null;

function fire(): void {
  if (exitIntentFired) return;
  exitIntentFired = true;
  if (onExitIntent) onExitIntent();
}

function handleMouseOut(e: MouseEvent): void {
  if (typeof document === 'undefined') return;
  const related = e.relatedTarget as Node | null;
  const toElement = (e as MouseEvent & { toElement?: Node }).toElement;
  const target = related ?? toElement;
  if (target != null && document.documentElement.contains(target)) return;
  if (e.clientY <= 0) fire();
}

function handleVisibilityChange(): void {
  if (
    typeof document !== 'undefined' &&
    document.visibilityState === 'hidden'
  ) {
    fire();
  }
}

export function initExitIntentBehavior(callback?: () => void): void {
  if (typeof window === 'undefined') return;
  onExitIntent = callback ?? null;
  exitIntentFired = false;

  if (mouseOutListener) {
    document.removeEventListener('mouseout', mouseOutListener);
  }
  mouseOutListener = handleMouseOut;
  document.addEventListener('mouseout', mouseOutListener);

  if (visibilityListener) {
    document.removeEventListener('visibilitychange', visibilityListener);
  }
  visibilityListener = handleVisibilityChange;
  document.addEventListener('visibilitychange', visibilityListener);
}

export function getExitIntentFired(): boolean {
  return exitIntentFired;
}

export function resetExitIntentState(): void {
  exitIntentFired = false;
}

export function destroyExitIntentBehavior(): void {
  if (mouseOutListener && typeof document !== 'undefined') {
    document.removeEventListener('mouseout', mouseOutListener);
  }
  mouseOutListener = null;
  if (visibilityListener && typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', visibilityListener);
  }
  visibilityListener = null;
  onExitIntent = null;
  exitIntentFired = false;
}
